module.exports = __webpack_public_path__ + "b90f65d20d457d63149c9c71ef8d0d54.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg15.jpeg
// module id = 23
// module chunks = 0